import { useBalanceApi } from "../api/BalanceApiClient";
import { BalanceFrontendService } from "../services/BalanceFrontendService";

export const useBalanceService = (): BalanceFrontendService =>
  new BalanceFrontendService(useBalanceApi());
